import { Box, EmptyState, HStack, Spinner, Text, VStack } from "@chakra-ui/react";

export type LoadingStateProps = {
  message?: string;
  loadingMessage?: string;
  loadingMessageSize?: "xl" | "lg" | "md" | "sm" | "xs";
  spinnerSize?: "xl" | "lg" | "md" | "sm" | "xs";
  variant?: "normal" | "inline";
  spinnerRef?: React.RefObject<HTMLDivElement | null>;
};

const LOADING_SPINNER_COLOR = "moveon.primary";
const INLINE_LOADING_MESSAGE_COLOR = "moveon.shell.mutedFg";

export default function LoadingState({
  message = "The system is working in the background.",
  loadingMessage = "Give it some time ...",
  loadingMessageSize = "md",
  spinnerSize = "md",
  variant = "normal",
  spinnerRef,
}: LoadingStateProps) {
  if (variant === "inline") {
    return (
      <HStack gap="2" justify="center">
        <Spinner size={spinnerSize} color={LOADING_SPINNER_COLOR} />
        <VStack align="start" gap={0}>
          <Text fontWeight="bold" fontSize="sm">
            {loadingMessage}
          </Text>
          <Text fontSize="xs" color={INLINE_LOADING_MESSAGE_COLOR}>
            {message}
          </Text>
        </VStack>
      </HStack>
    );
  }

  return (
    <EmptyState.Root>
      <EmptyState.Content>
        <EmptyState.Indicator>
          <Box
            ref={spinnerRef}
            role="status"
            aria-live="polite"
            tabIndex={0}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Spinner color={LOADING_SPINNER_COLOR} size={spinnerSize} />
          </Box>
        </EmptyState.Indicator>

        <VStack textAlign="center">
          <EmptyState.Title fontSize={loadingMessageSize}>
            {loadingMessage}
          </EmptyState.Title>
          <EmptyState.Description>{message}</EmptyState.Description>
        </VStack>
      </EmptyState.Content>
    </EmptyState.Root>
  );
}
